import React, {useContext, useState, useEffect} from 'react'
import {MyAccountContext} from '../../containers/Layout'
import {Typography, Grid, Paper} from '@material-ui/core'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import UserAccess from './UserAccess'
//import {myAccountSchema, is_hide_auth_type} from '../../utils/constants'
import FormBuilder from '../../../components/FormBuilder'
import {useFormReducerHook} from '../../../utils/customHooks'
import {ToastContext} from '../../../App'
import {TOAST_VARIANT} from '../../../utils/constants'
import Loader from '../../../components/Loader'
import {postAPIData, putAPIData, getClientProgramAPIData} from '../../services/myaccount'
import i18next from 'i18next'
import {fromArray} from '@amcharts/amcharts4/.internal/core/utils/Iterator'
import _ from 'lodash'

const AddEditUser = props => {
    const {showToast} = useContext(ToastContext)
    const {clientObject, myAccountSchema} = useContext(MyAccountContext)
    let formContent = myAccountSchema.myAccountSchema.filter(
        element => element.componentType.toLowerCase() === 'adduser'
    )

    formContent = Array.isArray(formContent) && JSON.stringify(formContent[0])
    formContent = JSON.parse(formContent)
    let basicInfo =
        (formContent.basicInformation &&
            Array.isArray(formContent.basicInformation) &&
            formContent.basicInformation[0].jsonschema) ||
        []

    const [loading, setloading] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const [userId, setUserId] = useState(null)
    const [userDetails, setUserDetails] = useState([])
    const [userInfo, setUserInfo] = useState({
        basicInformation: {
            firstname: '',
            middlename: null,
            lastname: '',
            emailaddress: '',
            contactnumber: '',
            inactive: true,
        },
        programaccess: [
            {
                clientprogramid: 1,
                program: '',
                loginname: '',
                clientprogramrolemappingid: 1,
                authenticationtypeid: 1,
                multifa: {
                    value: false,
                    label: 'No',
                    obj: {value: false, label: 'No'},
                },
                organizationaccess: [
                    {
                        cliententityid: 1,
                        isdeleted: false,
                        practicename: '',
                        clinicianlist: 'all',
                        locationlist: 'all',
                        edlist: 'all',
                        inactive: true,
                    },
                ],
            },
        ],
    })

    const [isRefresh, setIsRefresh] = useState(false)
    const [savedProgram, setSavedProgram] = useState({
        openProgramDialog: false,
        userid: '',
    })
    const {
        formData,
        updateFormData: setFormData,
        errorsData,
        updateValidationData,
        validate: validateBasicInfo,
        // validationData,
        updateEntireFormData,
    } = useFormReducerHook()

    // console.log('AddEditUser -> clientObject', clientObject)
    // console.log('AddEditUser -> props', props)

    useEffect(() => {
        updateEntireFormData(userInfo.basicInformation)
    }, [])

    useEffect(() => {
        if (props.object.userdetails && props.object.userdetails.programaccess) {
            updateEntireFormData(userInfo.basicInformation)
        }
    }, [userInfo])
    
    const updateUserDetails = (userDetails) => {
        setUserDetails(userDetails)
    }

    const getUserDetails = userid => {
        setUserId(userid)
        const callApi = async () => {
            var apiData = await getClientProgramAPIData(
                'cliententity/user/' + userid,
                {},
                {
                    'client-entity-id': clientObject.cliententityid,
                }
            )
            if (apiData && apiData.userdetails) {
                const userdetail = apiData.userdetails
                setUserDetails(apiData.userdetails)
                let newBasicInfo = {
                    basicInformation: {
                        firstname: userdetail.firstname,
                        middlename: userdetail.middlename,
                        lastname: userdetail.lastname,
                        inactive: !userdetail.inactive,
                        emailaddress: userdetail.emailaddress,
                        contactnumber: userdetail.contactnumber,
                    },
                    access: userInfo.programaccess,
                }
                setUserInfo(newBasicInfo)
                updateEntireFormData(newBasicInfo.basicInformation)
            }
            setloading(false)
        }
        callApi()
    }

    // useEffect(() => {
    //     if (props.object.userId !== userId && userId !== null) {
    //         getUserDetails(userId)
    //     }
    // }, [userId])

    useEffect(() => {
        if (props.object.userid) {
            setloading(true)
            getUserDetails(props.object.userid)
        }
    }, [props.object.userid, isRefresh])

    const updateMainFormData = accessData => {
        setUserInfo({...userInfo, access: [...accessData]})
    }

    const updateMainContainerValidate = (action, isValidProgram, accessData) => {
        let status = false
        if (validateBasicInfo() && isValidProgram) {
            const programaccess = accessData.map(oprogram => {
                const obj = oprogram.formData
                const orgAccess = oprogram.organization.map(oitem => {
                    const o = oitem.formData
                    const clinicianList =
                        o.clinicians && Array.isArray(o.clinicians)
                            ? o.clinicians
                                  .map(item => {
                                      return item.value
                                  })
                                  .join(',')
                            : o.clinicians

                    const locationList =
                        o.locations && Array.isArray(o.locations)
                            ? o.locations
                                  .map(item => {
                                      return item.value
                                  })
                                  .join(',')
                            : o.locations

                    const edlist =
                        o.eds && Array.isArray(o.eds)
                            ? o.eds
                                  .map(item => {
                                      return item.value
                                  })
                                  .join(',')
                            : o.eds

                    return {
                        cliententityid: o.cliententity
                            ? parseInt(o.cliententity.cliententityid)
                            : '',
                        practicename: o.cliententity ? o.cliententity.name : '',
                        clinicianlist: clinicianList,
                        locationlist:
                            obj.clientprogram.clientprogramid == 8 ? null : locationList,
                        edlist: obj.clientprogram.clientprogramid == 8 ? edlist : null,
                        inactive: !o.inactive,
                        isdeleted: oitem.isdeleted,
                        organizationaccessid: oitem.organizationaccessid,
                    }
                })

                orgAccess.map((org, index) => {
                    if (!org.cliententityid && org.isdeleted) {
                        orgAccess.splice(index, 1)
                    }
                })

                orgAccess.map((org, index) => {
                    if (!userId && org.isdeleted) {
                        orgAccess.splice(index, 1)
                    }
                })

                const clientprogramrolemappingid =
                    obj.userrole && Array.isArray(obj.userrole)
                        ? obj.userrole
                              .map(item => {
                                  return item.clientprogramrolemappingid
                              })
                              .join(',')
                        : obj.userrole &&
                          obj.userrole.clientprogramrolemappingid.toString()

                const rolename =
                    obj.userrole && Array.isArray(obj.userrole)
                        ? obj.userrole
                              .map(item => {
                                  return item.name
                              })
                              .join(',')
                        : obj.userrole && obj.userrole.name

                if (myAccountSchema.is_hide_auth_type) {
                    return {
                        clientprogramid: obj.clientprogram
                            ? obj.clientprogram.clientprogramid
                            : '',
                        program: obj.clientprogram ? obj.clientprogram.name : '',
                        loginname: obj.loginname,
                        clientprogramrolemappingid: clientprogramrolemappingid,
                        rolename: rolename,
                        // authenticationtypeid: obj.authenticationtype
                        //     ? obj.authenticationtype.authenticationtypeid
                        //     : '',
                        //inactive: !obj.inactive,
                        twofa: obj.multifa.value,
                        organizationaccess: orgAccess,
                    }
                } else {
                    return {
                        clientprogramid: obj.clientprogram
                            ? obj.clientprogram.clientprogramid
                            : '',
                        program: obj.clientprogram ? obj.clientprogram.name : '',
                        loginname: obj.loginname,
                        clientprogramrolemappingid: clientprogramrolemappingid,
                        rolename: rolename,
                        authenticationtypeid: obj.authenticationtype
                            ? obj.authenticationtype.authenticationtypeid
                            : '',
                        //inactive: !obj.inactive,
                        twofa: obj.multifa.value,
                        organizationaccess: orgAccess,
                    }
                }
            })
            let userObj = {
                firstname: formData.firstname,
                middlename: formData.middlename,
                lastname: formData.lastname,
                emailaddress: formData.emailaddress,
                contactnumber: formData.contactnumber,
                inactive: !formData.inactive,
                programaccess:
                    action === 'save' && programaccess.length > 1
                        ? programaccess
                        : programaccess[0],
            }

            if (userId && userDetails) {
                userObj.oldinactive = userDetails.oldinactive
                userObj.oldfirstname = userDetails.oldfirstname
                userObj.oldmiddlename = userDetails.oldmiddlename
                userObj.oldlastname = userDetails.oldlastname
                userObj.oldemailaddress = userDetails.oldemailaddress
                userObj.oldcontactnumber = userDetails.oldcontactnumber

                if (
                    userObj.programaccess &&
                    userObj.programaccess.length &&
                    userObj.programaccess.length > 0
                ) {
                    userDetails.programaccess.map(program => {
                        userObj.programaccess.map(uProgram => {
                            if (
                                program.clientprogram.clientprogramid.toString() ===
                                uProgram.clientprogramid.toString()
                            ) {
                                const oldClientprogramrolemappingid =
                                    program.role && Array.isArray(program.role)
                                        ? program.role
                                              .map(item => {
                                                  return item.oldclientprogramrolemappingid
                                              })
                                              .join(',')
                                        : program.role &&
                                          program.role.oldclientprogramrolemappingid.toString()

                                const oldRolename =
                                    program.role && Array.isArray(program.role)
                                        ? program.role
                                              .map(item => {
                                                  return item.oldrolename
                                              })
                                              .join(',')
                                        : program.role && program.role.oldrolename

                                uProgram.oldtwofa = program.oldtwofa
                                uProgram.oldclientprogramrolemappingid = oldClientprogramrolemappingid
                                uProgram.oldrolename = oldRolename
                                uProgram.oldorganizationaccess =
                                    program.oldorganizationaccess

                                uProgram.organizationaccess.map(uOrg => {
                                    program.organizationaccess.map(org => {
                                        if (
                                            uOrg.cliententityid.toString() ===
                                            org.cliententity.cliententityid.toString()
                                        ) {
                                            uOrg.oldinactive = org.oldinactive
                                            uOrg.oldlocationlist = org.oldlocationlist
                                            uOrg.oldedlist = org.oldedlist
                                            uOrg.oldclinicianlist = org.oldclinicianlist
                                        }
                                    })
                                })
                            }
                        })
                    })
                } else {
                    userDetails.programaccess.map(program => {
                        if (
                            program.clientprogram.clientprogramid.toString() ===
                            userObj.programaccess.clientprogramid.toString()
                        ) {
                            const oldClientprogramrolemappingid =
                                program.role && Array.isArray(program.role)
                                    ? program.role
                                          .map(item => {
                                              return item.oldclientprogramrolemappingid
                                          })
                                          .join(',')
                                    : program.role &&
                                      program.role.oldclientprogramrolemappingid.toString()

                            const oldRolename =
                                program.role && Array.isArray(program.role)
                                    ? program.role
                                          .map(item => {
                                              return item.oldrolename
                                          })
                                          .join(',')
                                    : program.role && program.role.oldrolename

                            userObj.programaccess.oldtwofa = program.oldtwofa
                            userObj.programaccess.oldclientprogramrolemappingid = oldClientprogramrolemappingid
                            userObj.programaccess.oldrolename = oldRolename
                            userObj.programaccess.oldorganizationaccess =
                                program.oldorganizationaccess

                            userObj.programaccess.organizationaccess.map(uOrg => {
                                program.organizationaccess.map(org => {
                                    if (
                                        uOrg.cliententityid.toString() ===
                                        org.cliententity.cliententityid.toString()
                                    ) {
                                        uOrg.oldinactive = org.oldinactive
                                        uOrg.oldlocationlist = org.oldlocationlist
                                        uOrg.oldedlist = org.oldedlist
                                        uOrg.oldclinicianlist = org.oldclinicianlist
                                    }
                                })
                            })
                        }
                    })
                }
            }

            status = false
            let toastMsg = ''
            setloading(true)
            const callApi = async () => {
                setloading(true)
                const data = userId
                    ? await putAPIData(`user/updateaccess/` + userId, userObj, {
                          'client-entity-id': clientObject.cliententityid,
                      })
                    : await postAPIData(`user/createaccess/`, userObj, {
                          'client-entity-id': clientObject.cliententityid,
                      })
                if (Object.keys(data).length > 0) {
                    if (data.error && Object.keys(data.error).length > 0) {
                        toastMsg = data.error.message
                        status = false
                        setSavedProgram({openProgramDialog: false, userid: ''})
                    } else {
                        status = true
                        if (action === 'save')
                            props.setRouter(props.object.backrouter || 'user')
                        else if (action === 'newaccess') {
                            setSavedProgram({
                                openProgramDialog: true,
                                userid: userId ? userId : data.success.figuserid,
                                clientprogramid: userObj.programaccess.clientprogramid,
                            })
                            setUserId(userId ? userId : data.success.figuserid)
                            getUserDetails(userId ? userId : data.success.figuserid)
                            //setIsRefresh(!isRefresh)
                        } else if (action === 'saveaccess') {
                            setSavedProgram({
                                openProgramDialog: false,
                                userid: userId ? userId : data.success.figuserid,
                            })
                            // setIsRefresh(!isRefresh)
                            setUserId(userId)
                            //getUserDetails(userId)
                        }
                        toastMsg = data.success.message
                    }
                }

                showToast({
                    open: true,
                    variant: status ? TOAST_VARIANT.SUCCESS : TOAST_VARIANT.ERROR,
                    message: toastMsg,
                })
                setloading(false)
            }
            callApi()
        }
    }

    if (loading) return <Loader type="page" />

    return (
        <div className="ma-main-page__wrapper  ">
            <Typography className="form-row--heading_h6" variant="h6" gutterBottom>
                <FontAwesomeIcon
                    icon={['fal', 'angle-left']}
                    onClick={() => props.setRouter(props.object.backrouter || 'user')}
                ></FontAwesomeIcon>
                &nbsp;
                {props.object.header + ' USER'}
            </Typography>
            {/* <Grid item xs={12} sm className="program-header__ttl"></Grid> */}

            <Paper className="user-manage__wrapper">
                <Grid container className="" spacing={3}>
                    <Grid item xs={12} className="">
                        <Typography variant="h5" className="accordion_title_h5">
                            Basic Information
                        </Typography>
                    </Grid>
                    <Grid item xs={12} className="">
                        <FormBuilder
                            fields={basicInfo.fields}
                            formData={formData}
                            setFormData={setFormData}
                            errorsData={errorsData}
                            updateValidation={updateValidationData}
                        />
                    </Grid>
                </Grid>
                <UserAccess
                    setRouter={props.setRouter}
                    backrouter={props.object.backrouter}
                    updateMainFormData={updateMainFormData}
                    updateMainContainerValidate={updateMainContainerValidate}
                    userDetails={userDetails}
                    setUserDetails={setUserDetails}
                    setIsRefresh={setIsRefresh}
                    isRefresh={isRefresh}
                    userid={props.object.userid}
                    setSavedProgram={setSavedProgram}
                    savedProgram={savedProgram}
                    setUserId={setUserId}
                    updateUserDetails={updateUserDetails}
                />
            </Paper>
        </div>
    )
}

export default AddEditUser
